import React  from "react";
import Paper from "./Paper";

const Tada = ({papers, trigger, colors})=> {

  const defaultColors = [ "#df4678", "#00cecb", "#995ae2", "#ffc857", "#ca3b4e" ];

  return (
    <div>
      {[...Array(papers).keys()].map((item)=> <Paper colors={colors || defaultColors} key={item} index={item} trigger={trigger} />)}
    </div>
  );
};


export default Tada;
